<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">Dedicated to:</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Kerry Conroy my sister</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Peter my husband</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">In loving memory of:</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Ethel Curnow née Stephen</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Carlyle Stephen</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Grace Vincent née Holland</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Jack Holland</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2468bc6a